import dayjs from 'dayjs'

export interface MeasurementLabelData {
  isFollowUp?: boolean
  followUpOrdinal?: number | null
  answerDate?: string | null
}

export const formatMeasurementDate = (value?: string | null): string | null => {
  if (!value || !dayjs(value).isValid()) return null
  return dayjs(value).format('DD/MM/YY')
}

export const formatMeasurementLabel = ({
  isFollowUp = false,
  followUpOrdinal = null,
  answerDate = null,
}: MeasurementLabelData): string => {
  const type = isFollowUp
    ? `Follow Up${followUpOrdinal ? ` ${followUpOrdinal}` : ''}`
    : 'Medición original'
  const date = formatMeasurementDate(answerDate)
  return date ? `${type} · ${date}` : type
}
